import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { Loader } from '../../../core/classes/loader';
import { LoaderState } from '../../../core/enums/loader-state';

/**
 * Component to display a Button with Loading indicator
 *
 * @example
 * <cfe-spinner-button
 *               [cssClass]="'btn btn-primary btn-sm'"
 *               [loader]="loader"
 *               [disabled]="false"
 *               [disableOnLoading]="true"
 *               [tabIndex]="0"
 *               [type]="'submit'"
 *               [value]="'Submit'"
 *               (clicked)="onSubmit($event)">
 * </cfe-spinner-button>
 */
@Component({
	selector: 'cfe-spinner-button',
	templateUrl: './spinner-button.component.html',
	styleUrls: ['./spinner-button.component.scss']
})
export class SpinnerButtonComponent implements OnInit, OnDestroy {
	/**
	 * Type of Button
	 */
	@Input() type = 'submit';

	/**
	 * Value of Button
	 */
	@Input() value = 'Button';

	/**
	 * CSS class of Button
	 */
	@Input() cssClass = 'btn btn-primary';

	/**
	 * A flag (boolean) as indication whether input field is disabled (true) or not (false)
	 */
	@Input() disabled = false;

	/**
	 * A flag (boolean) as indication whether input field is disabled (true) or not (false)
	 */
	@Input() disabledOnLoading = true;

	/**
	 * Loader instance to track loading states
	 */
	@Input() loader: Loader;

	/**
	 * Tab index for spinner button
	 */
	@Input() tabIndex: number;

	/**
	 * Show Icon in Button
	 */
	@Input() iconName: string;

	/*
	 * The id for the Button
	 */
	@Input() id: string;

	/**
	 * click event handler (optional)
	 */
	@Output() clicked: EventEmitter<any> = new EventEmitter<any>();

	private subscription: Subscription;

	state: LoaderState = 1;
	states = LoaderState;

	constructor() {}

	ngOnInit() {
		if (this.loader) {
			this.subscription = this.loader.getStateObservable().subscribe((state: LoaderState) => {
				this.state = state;
			});
		}
	}

	ngOnDestroy() {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}

	clickEvent(event) {
		if (!this.disabled) {
			this.clicked.emit(event);
		}
	}
}
